<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      addText="导出"
      :addBtnLoading="exporting"
      :handelAdd="handelExport"
      :ableSearch="ableSearch"
      :ableAdd="ableAdd"
    ></search-form>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="paginatedData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{ x: 'max-content' }"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'result'">
          {{ codeToText(record.result, loginState) }}
        </template>
        <template v-else-if="column.key === 'depart_id'">
          {{ codeToText(record.depart_id, Enum.dept.value) }}
        </template>
        <table_data_format
          v-else
          :record="record"
          :column="column"
        ></table_data_format>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getData } from '@/api/system_report/vehicle_reservation'
  import searchForm from '@/components/search_form'
  import dayjs from 'dayjs'
  import { codeToText, constantToOptions } from '@/utils/format'
  import { loginState } from '@/utils/common'
  import table_data_format from '@/components/table_data_format'
  import { fileExport } from '@/utils/download'

  //初始化
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    true
  )
  const ableAdd = computed(() =>
    true
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'select',
      label: '园区类型',
      field: 'visit_area',
      storeOptions: 'areaType',
      width: '140px',
    },
    {
      type: 'dateRange',
      startField: 'start_time',
      endField: 'end_time',
      label: '时间',
      defaultStart: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
      // defaultEnd: dayjs().add(7, 'day').format('YYYY-MM-DD'),
      defaultEnd: dayjs().format('YYYY-MM-DD'),
      format: 'YYYY-MM-DD',
      allowClear: false,
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setVehicleReservation', params)
  }

  //2、表格
  const columns = [
    {
      title: '日期',
      dataIndex: 'stat_date',
      key: 'stat_date',
      align: 'left',
    },
    {
      title: '访问园区',
      dataIndex: 'visit_area',
      key: 'visit_area',
      align: 'left',
    },
    {
      title: '当日新增预约单数',
      dataIndex: 'added',
      key: 'added',
      align: 'left',
    },
    {
      title: '待企业审核预约单数',
      dataIndex: 'company_check_pending',
      key: 'company_check_pending',
      align: 'left',
    },
    {
      title: '企业审核未通过预约单数',
      dataIndex: 'company_check_disagree',
      key: 'company_check_disagree',
      align: 'left',
    },
    {
      title: '企业审核通过预约单数',
      dataIndex: 'company_check_agree',
      key: 'company_check_agree',
      align: 'left',
    },
    {
      title: '待大队审核预约单数',
      dataIndex: 'check_pending',
      key: 'check_pending',
      align: 'left',
    },
    {
      title: '大队审核未通过预约单数',
      dataIndex: 'check_disagree',
      key: 'check_disagree',
      align: 'left',
    },
    {
      title: '大队审核通过预约单数',
      dataIndex: 'check_agree',
      key: 'check_agree',
      align: 'left',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)

  // 分页配置
  const pagination = ref({
    current: 1,
    pageSize: 10,
    total: 0,
    showLessItems: true,
    showQuickJumper: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  // 计算分页后的数据
  const paginatedData = computed(() => {
    const start = (pagination.value.current - 1) * pagination.value.pageSize
    const end = start + pagination.value.pageSize
    return tableData.value.slice(start, end)
  })

  function handleTableChange(paginationInfo) {
    pagination.value.current = paginationInfo.current
    pagination.value.pageSize = paginationInfo.pageSize
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data
      // 更新分页总数
      pagination.value.total = data.length
      // 如果当前页超出范围，重置到第一页
      const maxPage = Math.ceil(data.length / pagination.value.pageSize)
      if (pagination.value.current > maxPage && maxPage > 0) {
        pagination.value.current = 1
      }
    })
  }
  
  const cachedSearchParams = computed(() => store.state.search.vehicleReservation)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })

  //导出
  const exporting = ref(false)
  async function handelExport() {
    exporting.value = true
    const formState = searchFormRef.value?.formState
    fileExport({
      onFinally: () => (exporting.value = false),
      name: `车辆预约单统计导出${
        formState.start_time
      }至${formState.end_time}.xlsx`,
      // url: `/api/statistics/car_application_state/export?start_time=${formState.start_time}&end_time=${formState.end_time}`,
      url: `/api/v3/statistics/car_application_state/export?start_time=${formState.start_time}&end_time=${formState.end_time}&visit_area=${formState.visit_area}`,
    })
  }
</script>
